/**
 * On manual "Nachversand" eligibility changes:
 * null -> true   => ✅ recovery for a failed onboarding computation
 * null -> false  => ✅ recovery for a failed onboarding computation
 * true -> false  => ✅ one-time deactivation, final
 * false -> true  => ❌ forbidden for everyone in the app; only a developer via direct DB access
 * x -> null      => ❌ "not computed" can never be restored
 * x -> x         => ❌ no-op, disallowed since it is useless
 */
export const canSetNachversandEligibility = (
  oldValue: boolean | null,
  newValue: boolean | null,
): boolean => {
  if (newValue === null) {
    return false;
  }
  if (oldValue === null) {
    return true;
  }
  return oldValue === true && newValue === false;
};
